import * as React from 'react';
import { BloodworkAnalysis, RootCauseCategory, FurtherConsiderations, Section } from '../../models';

type Props = {
    bloodworkAnalysis: BloodworkAnalysis;
    furtherConsiderations: FurtherConsiderations;
    section: Section;
    tab: string;
};

export class FurtherConsiderationsSection extends React.Component<Props, {}> {
    furtherConsiderationsForPossibleRootCauses(bloodworkAnalysis: BloodworkAnalysis): JSX.Element {
    const { section } = this.props;

    // Original list from the model
    const categories = bloodworkAnalysis.possibleRootCauseCategoriesFor(section) || [];

    // WBC-only: float the 110xx “Immune System Abnormality …” items to the top.
    // Keep other sections’ order unchanged.
    const prioritized = (section === Section.WBC)
        ? categories
            .map((c, idx) => {
                const id = Number(c.rootCauseCategory);
                const is110xx = id >= 11010 && id <= 11099; // the probability-driven WBC group
                return { c, idx, id, is110xx };
            })
            .sort((a, b) => {
                // 1) 110xx first
                if (a.is110xx !== b.is110xx) return a.is110xx ? -1 : 1;
                // 2) Within 110xx, larger id first (so 11099 before 11095, etc.)
                if (a.is110xx && b.is110xx) return b.id - a.id;
                // 3) Everything else stays in the original order
                return a.idx - b.idx;
            })
            .map(x => x.c)
        : categories;

    return (
        <span>
            {prioritized.map((category) => {
                return this.furtherConsiderationsFor(category.rootCauseCategory);
            })}
        </span>
    );
}
    furtherConsiderationsFor(rootCauseCategory: RootCauseCategory): JSX.Element {
        const { furtherConsiderations, section, tab } = this.props;
        // console.log('furtherConsiderationsFor: rootCauseCategory:', rootCauseCategory, ' section:', section, ' tab:', tab);
        return (
            <span key={rootCauseCategory}>
                {
                    // tslint:disable-next-line:max-line-length
                    furtherConsiderations.findConsiderations(rootCauseCategory, section, tab).map((consideration, cindex) => {
                        return (
                            <span key={cindex}>
                                <span key={`title-${cindex}`} className="consideration-title">
                                    {consideration.title}
                                </span>
                                <ul>
                                {
                                    consideration.items.map((item, itemIndex) => {
                                        return <li key={`${rootCauseCategory}-${cindex}-${itemIndex}`}>{item}</li>;
                                    })
                                }
                                </ul>
                            </span>
                        );

                    })
                }
            </span>
        );  
    }

    render() {
        const { bloodworkAnalysis } = this.props;

        if (!bloodworkAnalysis.bloodwork) {
            return null;
        }

        return this.furtherConsiderationsForPossibleRootCauses(bloodworkAnalysis) 
    }
}